// Snapshot av URL:ens sökväg vid appstart. Lazy-laddade sidor (t.ex. via @loadable/component)
// kan hinna montera långt efter att navigationSlice redan har ersatt URL:en
// (se addToBrowserHistory i navigationSlice.ts), vilket gör att window.location.search
// inte längre går att lita på när sidan väl läser den. Denna modul körs synkront vid
// bundle-start, innan någon sådan ersättning hunnit ske, och sparar undan sökvägen.
export const initialSearch = window.location.search;
